// extracted by mini-css-extract-plugin
export var accordion = "_ey-0";
export var chevron = "_ey-3";
export var closed = "_ey-2";
export var content = "_ey-4";
export var open = "_ey-1";
export var rotate = "_ey-5";